import React from 'react'
import PageTitle from "./PageTitle";
import skillsList from "../Lists/Skills";

const Skills = (props) => {

    return (
        <section>
            <div className='skills-wrapper common-padding'>
                <PageTitle title="Skills" />
                <div className="mt-4 w-100">
                    <div className="skillCard-wrapper">
                        {skillsList && skillsList.map((skill, i) => (
                            <div className="skillCard rounded-lg" key={i}>
                                <div className="skill-title">
                                    {/* <img src={skill.logo} className="p-1 bg-light shadow-sm rounded-pill my-1 mx-2" width="40" alt="logo" /> */}
                                    {skill.name}
                                </div>
                                <div className="text-left skill-bar rounded-pill">
                                    <hr
                                        className="py-1 common-divider rounded-pill mx-0 mb-0 mt-2"
                                        width={`${skill.level}%`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("experience")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("projects")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default Skills